import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Users, FileText, TrendingDown, CheckCircle, Download } from "lucide-react";

interface GlobalStats {
  total_users: number;
  total_forms: number;
  total_sessions: number;
  total_completed: number;
  total_pdf_downloads: number;
}

interface UserRow {
  role: "admin" | "pro" | "free";
}

interface FormRow {
  id: string;
  title: string;
  owner_email: string;
  sessions_count: number;
  completed_count: number;
}

interface Props {
  globalStats: GlobalStats;
  users: UserRow[];
  forms: FormRow[];
}

export default function OverviewTab({ globalStats, users, forms }: Props) {
  return (
    <div className="space-y-8">
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-5">
        <Card>
          <CardHeader className="pb-2">
            <CardDescription className="flex items-center gap-2">
              <Users className="h-4 w-4" />
              Total Usuários
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{globalStats.total_users}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription className="flex items-center gap-2">
              <FileText className="h-4 w-4" />
              Total Formulários
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{globalStats.total_forms}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription className="flex items-center gap-2">
              <TrendingDown className="h-4 w-4" />
              Total Leads
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{globalStats.total_sessions}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription className="flex items-center gap-2">
              <CheckCircle className="h-4 w-4" />
              Completados
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{globalStats.total_completed}</div>
          </CardContent>
        </Card>
        <Card>
          <CardHeader className="pb-2">
            <CardDescription className="flex items-center gap-2">
              <Download className="h-4 w-4" />
              PDFs Baixados
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{globalStats.total_pdf_downloads}</div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Distribuição de Planos</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-muted-foreground">
                {users.filter((u) => u.role === "free").length}
              </div>
              <div className="text-sm text-muted-foreground">Free</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-primary">
                {users.filter((u) => u.role === "pro").length}
              </div>
              <div className="text-sm text-muted-foreground">Pro</div>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500">
                {users.filter((u) => u.role === "admin").length}
              </div>
              <div className="text-sm text-muted-foreground">Admin</div>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Top 5 Formulários por Leads</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Formulário</TableHead>
                <TableHead>Dono</TableHead>
                <TableHead className="text-right">Leads</TableHead>
                <TableHead className="text-right">Completados</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {forms
                .slice()
                .sort((a, b) => b.sessions_count - a.sessions_count)
                .slice(0, 5)
                .map((form) => (
                  <TableRow key={form.id}>
                    <TableCell className="font-medium">{form.title}</TableCell>
                    <TableCell className="text-muted-foreground">{form.owner_email}</TableCell>
                    <TableCell className="text-right">{form.sessions_count}</TableCell>
                    <TableCell className="text-right">{form.completed_count}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
